import React from 'react';
import PropTypes from 'prop-types';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');


function Flash({ show, msg }) {
  if (show) {
    return (
      <div className="email-pdf-alert flash-success">
        <div className="alert alert-success">
          { msg }
        </div>
      </div>
    );
  }
  return null;
}

Flash.defaultProps = {
  show: false,
  msg: '',
};

Flash.propTypes = {
  show: PropTypes.bool,
  msg: PropTypes.string,
};

export default Flash;




// WEBPACK FOOTER //
// ./src/components/case/docket/Flash.jsx